module.exports = __webpack_public_path__ + "egto-logo-662b118d4e1a1bbb3f185de31f36cef0.svg";